import PropTypes from 'prop-types';
import Modal from 'components/templates/Modal/Modal';
import * as ALOOMA from 'consts/alooma';
import ModalBodyGiftCardNoEmail from 'components/molecules/ModalBodyGiftCardNoEmail/ModalBodyGiftCardNoEmail';

const ModalGiftCardNoEmail = props => {
  const { closeModal, sourcePage } = props;

  return (
    <Modal
      source={sourcePage}
      aloomaModalType={ALOOMA.MODAL_TYPES.POPUP}
      aloomaModalName={ALOOMA.MODAL_NAMES.GIFT_CARD_NO_EMAIL}
      onClose={closeModal}
      sendPageView={false}
    >
      <ModalBodyGiftCardNoEmail {...props} />
    </Modal>
  );
};

ModalGiftCardNoEmail.propTypes = {
  closeModal: PropTypes.func.isRequired,
  sourcePage: PropTypes.string.isRequired,
};

export default ModalGiftCardNoEmail;
